import type { SeoPageConfig } from '../types/Seo';
import { FEATURES_PAGE_SOFTWARE_SCHEMA, landingSoftwareApplicationSchema } from './schemas';
import { seoTitle } from './site';
import { SEO_MARKETING_ARTICLES } from '../content/marketingArticles';

export const SEO_HOME: SeoPageConfig = {
  title: seoTitle('Таймер для выступлений и мероприятий'),
  description:
    'preztimer — веб-сервис контроля тайминга на мероприятии: панель у команды, экран таймера для спикера, сообщения в зал. Запуск в браузере.',
  h1: 'Контроль тайминга мероприятий любого масштаба',
  summary:
    'Единая система для управления выступлениями, спикерами и временем — без срывов и хаоса.',
  path: '/',
  schema: landingSoftwareApplicationSchema,
};

export const SEO_FEATURES: SeoPageConfig = {
  title: seoTitle('Онлайн таймер для мероприятий'),
  description:
    'Панель управления, экран таймера для спикера, сообщения и команда в одной комнате. Лицензии Базовый и Профи — сравните на странице цен или запустите в браузере.',
  h1: 'Онлайн таймер для мероприятий',
  summary:
    'От небольших событий до крупных трансляций — управляйте временем, спикерами и эфиром в одной системе.',
  path: '/features',
  schema: FEATURES_PAGE_SOFTWARE_SCHEMA,
};

export const SEO_CONFERENCES: SeoPageConfig = {
  title: seoTitle('Таймер для конференций'),
  description:
    'Программа дня в одной комнате: панель управления с телефона, экран таймера у трибуны и в зале, подсказки спикеру в реальном времени. Запустите в браузере.',
  h1: 'Таймер для конференций',
  summary:
    'Одна комната — общая ссылка на программу конференции: панель управления для команды и экран таймера для спикера в браузере.',
  path: '/use-cases/conferences',
};

export const SEO_PRESENTATIONS: SeoPageConfig = {
  title: seoTitle('Таймер для презентаций и докладов'),
  description:
    'Доклад или питч: экран таймера по ссылке, подсказки с панели управления. Без отдельной программы на ПК спикера — создайте комнату и проверьте слот.',
  h1: 'Таймер для презентаций и докладов',
  summary:
    'Один экран с отсчётом рядом со слайдами: регламент видит и спикер, и команда.',
  path: '/use-cases/presentations',
};

export const SEO_TIMER_EVENT_PRODUCTION: SeoPageConfig = {
  title: seoTitle('Таймер для продакшн-команд'),
  description:
    'Тайминг шоу в одной комнате: панель управления у оператора, экран таймера для спикера и зала по ссылке, сообщения и зоны в эфире. Без кабелей, в браузере.',
  h1: 'Таймер для продакшн-команд',
  summary:
    'Режиссёр, оператор и ведущий видят одно время: панель управления и экран таймера для спикера — в браузере.',
  path: '/use-cases/timer-event-production',
};

export const SEO_MEETING_TIMER: SeoPageConfig = {
  title: seoTitle('Таймер для совещаний'),
  description:
    'Таймер для совещаний и планёрок: видно, чей черёд говорить, тайм-бокс на участника, сообщения и цветовые зоны на экране. Бесплатно, в браузере, без установки.',
  h1: 'Таймер для совещаний',
  summary:
    'Тайм-бокс на каждого участника: видно, чей сейчас черёд говорить, а сообщения и зоны держат регламент встречи.',
  path: '/use-cases/meeting-timer',
};

export const SEO_ONLINE_TIMER_EDUCATION: SeoPageConfig = {
  title: seoTitle('Онлайн-таймер для урока'),
  description:
    'Онлайн-таймер для урока, занятий и экзаменов: ученики видят остаток времени на экране класса, учитель держит расписание. Бесплатно, в браузере, без установки.',
  h1: 'Онлайн-таймер для урока',
  summary:
    'Таймер на каждый урок и активность: ученики видят остаток времени, а учитель держит расписание занятий.',
  path: '/use-cases/online-timer-for-education',
};

export const SEO_STREAM_TIMER: SeoPageConfig = {
  title: seoTitle('Таймер для стрима и трансляций'),
  description:
    'Таймер для стрима, трансляций и турниров: добавьте экран таймера в OBS как Browser Source, управляйте с телефона — сегменты, паузы, сообщения. В браузере.',
  h1: 'Таймер для стрима и трансляций',
  summary:
    'Экран таймера как Browser Source в OBS, управление с телефона: сегменты, паузы и сообщения в эфире.',
  path: '/use-cases/stream-timer',
};

export const SEO_BROADCAST_TIMER: SeoPageConfig = {
  title: seoTitle('Таймер для эфира и вещания'),
  description:
    'Таймер для эфира и вещания: расписание шоу по сегментам, старт в заданное время, сообщения и цветовые зоны на экране, общий доступ команде. В браузере.',
  h1: 'Таймер для эфира и вещания',
  summary:
    'Расписание эфира по сегментам, старт в заданное время и сообщения на экране — для команды на площадке и удалённо.',
  path: '/use-cases/broadcast-timer',
};

export const SEO_WORKOUT_TIMER: SeoPageConfig = {
  title: seoTitle('Таймер для тренировок и фитнеса'),
  description:
    'Таймер для тренировок и фитнеса: интервальный таймер на любой экран, полноэкранный режим, цветовой прогресс-бар и зоны. Бесплатно, в браузере.',
  h1: 'Таймер для тренировок и фитнеса',
  summary:
    'Интервальный таймер для зала и студии: полноэкранный отсчёт на ТВ, цветовой прогресс-бар, зоны и мигание перед концом.',
  path: '/use-cases/workout-timer',
};

export const SEO_TRADE_SHOW_TIMER: SeoPageConfig = {
  title: seoTitle('Таймер для выставки и экспо'),
  description:
    'Таймер для выставки и экспо: программа из нескольких докладчиков, отсчёт для каждого, старт по времени, сообщения и экран на стенде. Бесплатно, в браузере.',
  h1: 'Таймер для выставки и экспо',
  summary:
    'Программа выставочного дня по докладчикам: отсчёт для каждого, старт по времени и крупный экран таймера на стенде.',
  path: '/use-cases/trade-show-timer',
};

export const SEO_WEBINAR_TIMER: SeoPageConfig = {
  title: seoTitle('Таймер для вебинара'),
  description:
    'Таймер для вебинара: программа, обратный отсчёт и сообщения спикерам в одном окне — рядом с Zoom, Teams и YouTube. Бесплатно, в браузере, без установки.',
  h1: 'Таймер для вебинара',
  summary:
    'Программа, обратный отсчёт и сообщения спикерам в одном окне — рядом с любой платформой вебинара.',
  path: '/use-cases/webinar-timer',
};

export const SEO_CHURCH_TIMER: SeoPageConfig = {
  title: seoTitle('Таймер для церкви и богослужений'),
  description:
    'Таймер для церкви и богослужений: порядок служения по частям, отсчёт спикеру на экране, сообщения с телефона. Без оборудования, бесплатно, в браузере.',
  h1: 'Таймер для церкви и богослужений',
  summary:
    'Порядок служения по частям, отсчёт спикеру на экране и сообщения с телефона — без дорогого оборудования.',
  path: '/use-cases/church-timer',
};

export const SEO_PRICING: SeoPageConfig = {
  title: seoTitle('Цены'),
  description:
    'Лицензии preztimer в рублях: Базовый и Профи — лимиты комнат, таймеров на сцене, экрана таймера для спикера и команды. Сравните на странице.',
  h1: 'Цены',
  summary:
    'Подберите лицензию под формат мероприятия: от быстрых запусков до полного продакшн-контроля.',
  path: '/pricing',
};

export const SEO_CHANGELOG: SeoPageConfig = {
  title: seoTitle('Изменения продукта'),
  description:
    'Журнал изменений preztimer: новые функции, правки панели управления и экрана таймера, исправления по обратной связи организаторов.',
  h1: 'Что нового',
  summary:
    'Актуальные релизы preztimer: новые функции, правки интерфейса и исправления по обратной связи.',
  path: '/changelog',
};

export const SEO_FAQ: SeoPageConfig = {
  title: seoTitle('Частые вопросы'),
  description:
    'Установка, гостевая комната, другой браузер и устройство, вебинары, экран таймера для спикера, лицензии и лимиты preztimer — краткие ответы.',
  h1: 'Частые вопросы',
  summary:
    'Ответы об установке, комнатах, экране таймера, вебинарах и лицензиях Базовый и Профи — в одном разделе.',
  path: '/faq',
};

export const SEO_GUIDES_INDEX: SeoPageConfig = {
  title: seoTitle('Руководства по таймингу мероприятий'),
  description:
    'Гайды preztimer: конференции, вебинары, презентации, совещания и сравнения с альтернативами. Пошаговые сценарии для команды и зала.',
  h1: 'Руководства',
  summary:
    'Подборка материалов о контроле времени на сцене, в эфире и на площадке — с ссылками на функции и цены.',
  path: '/guides',
};

export const SEO_AUTH: SeoPageConfig = {
  title: seoTitle('Вход и регистрация'),
  description:
    'Вход в preztimer: ссылка на почте, Google, Яндекс и VK (в разработке) — тайминг и комнаты мероприятий.',
  h1: 'Вход и регистрация',
  summary:
    'Войдите в preztimer, чтобы сохранять комнаты и менять лицензию — ссылка на почте, Google или Яндекс.',
  path: '/auth',
  noindex: true,
};

export const SEO_DOCS: SeoPageConfig = {
  title: seoTitle('Документация'),
  description:
    'Как устроен preztimer: комната, панель управления, экран таймера и синхронизация тайминга на мероприятии.',
  h1: 'Документация',
  summary:
    'Схема работы: создайте комнату, ведите слоты с панели управления, откройте экран таймера для спикера по ссылке.',
  path: '/docs',
  noindex: true,
};

export const SEO_DASHBOARD: SeoPageConfig = {
  title: seoTitle('Рабочий стол'),
  description:
    'Создание комнат, список мероприятий и команда — панель организатора preztimer.',
  h1: 'Рабочий стол',
  summary:
    'Личные комнаты, вход по коду и приглашения в команду — рабочая область организатора preztimer.',
  path: '/dashboard',
  noindex: true,
};

export const SEO_ACCOUNT: SeoPageConfig = {
  title: seoTitle('Аккаунт'),
  description: 'Профиль и данные аккаунта preztimer.',
  h1: 'Аккаунт',
  summary: 'Имя, лицензия Базовый или Профи и параметры аккаунта preztimer в одном разделе.',
  path: '/account',
  noindex: true,
};

export function seoRoomPage(roomId: string | undefined): SeoPageConfig {
  return {
    title: seoTitle('Управление комнатой'),
    description:
      'Панель управления таймингом, таймерами и сообщениями в комнате preztimer.',
    h1: 'Панель управления',
    summary:
      'Таймеры, сообщения и участники комнаты — управление в реальном времени с панели preztimer.',
    path: roomId ? `/room/${roomId}` : '/room',
    noindex: true,
  };
}

export function seoViewerPage(roomId: string | undefined): SeoPageConfig {
  return {
    title: seoTitle('Экран таймера'),
    description:
      'Экран таймера и сообщений для спикера в реальном времени (preztimer).',
    h1: 'Экран таймера',
    summary:
      'Полноэкранный отсчёт и короткие сообщения для спикера или зала — синхронно с панелью.',
    path: roomId ? `/viewer/${roomId}` : '/viewer',
    noindex: true,
  };
}

/** Неизвестный маршрут SPA: canonical на фактический путь, без индексации. */
export function seoNotFoundPage(pathname: string): SeoPageConfig {
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return {
    title: seoTitle('Страница не найдена'),
    description:
      'Запрошенная страница в preztimer отсутствует. Откройте главную или раздел с возможностями.',
    h1: 'Страница не найдена',
    summary:
      'Проверьте адрес или перейдите на главную и в раздел с возможностями preztimer.',
    path: path || '/',
    noindex: true,
  };
}

/** Публичные маршруты: отдельный HTML shell в dist для raw meta/canonical (без выполнения JS). */
export const SEO_MARKETING_PRERENDER_PAGES: SeoPageConfig[] = [
  SEO_FEATURES,
  SEO_PRICING,
  SEO_CHANGELOG,
  SEO_FAQ,
  SEO_GUIDES_INDEX,
  SEO_CONFERENCES,
  SEO_PRESENTATIONS,
  SEO_TIMER_EVENT_PRODUCTION,
  SEO_MEETING_TIMER,
  SEO_ONLINE_TIMER_EDUCATION,
  SEO_STREAM_TIMER,
  SEO_BROADCAST_TIMER,
  SEO_WORKOUT_TIMER,
  SEO_TRADE_SHOW_TIMER,
  SEO_WEBINAR_TIMER,
  SEO_CHURCH_TIMER,
  ...SEO_MARKETING_ARTICLES,
];

/** Статические маршруты для проверок и навигации по конфигу. */
export const SEO_STATIC_PAGES: SeoPageConfig[] = [
  SEO_HOME,
  SEO_FEATURES,
  SEO_CONFERENCES,
  SEO_PRESENTATIONS,
  SEO_TIMER_EVENT_PRODUCTION,
  SEO_MEETING_TIMER,
  SEO_ONLINE_TIMER_EDUCATION,
  SEO_STREAM_TIMER,
  SEO_BROADCAST_TIMER,
  SEO_WORKOUT_TIMER,
  SEO_TRADE_SHOW_TIMER,
  SEO_WEBINAR_TIMER,
  SEO_CHURCH_TIMER,
  SEO_PRICING,
  SEO_CHANGELOG,
  SEO_FAQ,
  SEO_GUIDES_INDEX,
  ...SEO_MARKETING_ARTICLES,
  SEO_AUTH,
  SEO_DOCS,
  SEO_DASHBOARD,
  SEO_ACCOUNT,
];
